import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { MiddlewareAPI } from '../../../config/api';
import { IBadRequestResponse } from '../../../interfaces/IBadRequestResponse';
import { ICubage } from '../../../interfaces/response/Cubage/ICubage';
import { ICubageRespone } from '../../../interfaces/response/Cubage/ICubageResponse';

export const ObterCubagens = createAsyncThunk(
  'clientsData/ObterCubagens',
  async (args, { rejectWithValue }): Promise<ICubageRespone | any> => {
    try {
      const response = await MiddlewareAPI.get(`/v1/Cubagem`);

      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);

export const EditCubagens = createAsyncThunk(
  'clientsData/EditCubagens',
  async (
    args: {
      body: ICubage;
    },
    { rejectWithValue }
  ): Promise<ICubageRespone | any> => {
    try {
      const response = await MiddlewareAPI.put(`/v1/Cubagem`, args.body);

      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);

export const AddCubagens = createAsyncThunk(
  'clientsData/AddCubagens',
  async (
    args: {
      body: ICubage;
    },
    { rejectWithValue }
  ): Promise<ICubageRespone | any> => {
    try {
      const response = await MiddlewareAPI.post(`/v1/Cubagem`, args.body);

      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);
